// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OneToOneOutlinedSvg from "@ant-design/icons-svg/es/asn/OneToOneOutlined";
import AntdIcon from '../components/AntdIcon';

var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: OneToOneOutlinedSvg
  }));
};

OneToOneOutlined.displayName = 'OneToOneOutlined';
export default React.forwardRef(OneToOneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/OneToOneOutlined.js
// module id = 1531
// module chunks = 0